export enum ContactType {
  InBoundCall = "IBC",
  Chat = "Chat",
  WebForm = "WebForm",
  AutoDial = "AutoDial",
  OutBoundCall = "OBC"
}

export enum DisqualReason {
  Age = "Age",
  BMI = "BMI",
  MedicalNonCandidate = "Medical Noncandidate"
}

export enum LeadExternalSystem {
  Email = "InContact GEM-vNext/Email",
  InContactChat = "InContact GEM-vNext/Chat",
  OutboundDial = "SonoBello.GEM.Functions.Outbound.Dial",
  SMS = "InContact GEM-vNext/SMS",
  WebForm = "DI Form Processing",
  InBoundCall = "InContact GEM-vNext/MainIVR",
  FrontEnd = "SonoBello.GEM.API.Frontend"
}

export const LeadExternalSystemMap: Record<LeadExternalSystem, string> = {
  [LeadExternalSystem.Email]: "Email",
  [LeadExternalSystem.InContactChat]: "Chat",
  [LeadExternalSystem.OutboundDial]: "Outbound Dial",
  [LeadExternalSystem.SMS]: "SMS",
  [LeadExternalSystem.WebForm]: "Web Form",
  [LeadExternalSystem.InBoundCall]: "Inbound Call",
  [LeadExternalSystem.FrontEnd]: "Outbound Dial"
};

export enum LeadResultType {
  BadLead = "Bad Lead",
  Booked = "Booked",
  ExistingPatient = "Existing Patient",
  OtherProcedures = "Other Procedures",
  NotReached = "Not Reached",
  MedicalEscalation = "Medical Escalation"
}

export enum NotOfferedProcedure {
  Other = "Other"
}
